import { AUTH_SUCCESS, LOGOUT, UPDATE_AUTH_TOKEN, VALIDATE_OTP_SUCCESS } from "../actions/types"

const initialState = {
    isLoggedIn: false
}

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_SUCCESS:
            const {
                _id,
                mobileNumber,
                isMobileNumberVerified,
                fullName
            } = action.payload;
            return Object.assign({}, state, {
                _id,
                mobileNumber,
                isMobileNumberVerified,
                fullName,
                isLoggedIn: true,
            });
        case UPDATE_AUTH_TOKEN:
            const { accessToken } = action.payload;
            return Object.assign({}, state, {
                accessToken,
            });
        case VALIDATE_OTP_SUCCESS:
            console.log(action.payload);
            return Object.assign({}, state, {
                isOtpVerified: true,
                isLoggedIn: true,
                _id: action.payload._id,
                mobileNumber: action.payload.mobileNumber,
                isMobileNumberVerified: action.payload.isEmailverified,
                fullName: action.payload.fullName,
                role: action.payload.role,
            });
        case LOGOUT:
            return Object.assign({}, state, {
                _id: '',
                mobileNumber: '',
                isMobileNumberVerified: '',
                isEmailverified: '',
                fullName: '',
                accessToken: '',
            });
        default:
            return state
    }
}